// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { Col, Row } from "react-grid-system";
import { STable } from "../../styles/AdminSearchScore";
import EditIcon from "../../assets/img/icons/edit-black.svg";
import DeleteIcon from "../../assets/img/icons/delete.svg";
import { useState, useEffect } from "react";
import { StyledModal } from "../../styles/StyledModal";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import ReactModal from "react-modal";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { getUser } from "../../api/admin/user";
import { ChangeUserPassword } from "../Admin";
import { DeleteUser } from "../Admin/DeleteUser";
import { UserType } from "../../api/admin/user";
import { userRoles } from "../../constants/role";

type UsersListProps = {
	refetchUsers: () => void;
	users: UserType[] | undefined;
};

export const UsersList = (props: UsersListProps) => {
	const { refetchUsers, users } = props;
	const { axiosPrivate } = useAxiosPrivate();
	const [userId, setUserId] = useState<number | undefined>(undefined);
	const [modalIsOpen, setModalIsOpen] = useState(false);
	const [modalType, setModalType] = useState<"EDIT" | "DELETE" | undefined>(undefined);
	const [currentRole, setCurrentRole] = useState<"root" | "admin" | null>(null);
	const [currentUserId, setCurrentUserId] = useState<number | null>(null);

	const handleEdit = (id: number) => {
		setUserId(id);
		setModalType("EDIT");
		setModalIsOpen(true);
	};

	const handleDelete = (id: number) => {
		setUserId(id);
		setModalType("DELETE");
		setModalIsOpen(true);
	};

	const handleClose = () => {
		setModalIsOpen(false);
		setUserId(undefined);
		setModalType(undefined);
	};

	useEffect(() => {
		const fetchUser = async () => {
			try {
				const profileRes = await axiosPrivate.get("/user/profile.json");
				const userId = profileRes.data.id;
				setCurrentUserId(userId);
				const user = await getUser(axiosPrivate, userId);
				const roles = user.roles;

				if (roles.includes("ROLE_ROOT")) {
					setCurrentRole("root");
				} else if (roles.includes("ROLE_ADMIN")) {
					setCurrentRole("admin");
				} else {
					setCurrentRole(null);
				}
			} catch (err) {
				console.error("Failed to fetch current user", err);
			}
		};
		fetchUser();
	}, []);

	const canManageUser = (targetRoles: string[]): boolean => {
		if (currentRole === "root") return true;
		if (currentRole === "admin" && targetRoles.includes("ROLE_USER")) return true;
		return false;
	};

	const filteredUsers = users?.filter(user => {
		if (currentRole === "root") return true;
		if (currentUserId === null) return false;

		return user.createdById === currentUserId || user.id === currentUserId;
	});

	const mapped = filteredUsers?.map((user) => (
		<tr key={user.id}>
			<td>{user.username}</td>
			<td colSpan={2}>
				{user.firstName} {user.lastName}
			</td>
			<td colSpan={2}>{user.email}</td>
			<td>
				{user.roles.map((role, i) => {
					if (i > 0) {
						return <span key={i}>, {userRoles.find((r) => r.value === role)?.label}</span>;
					}
					return <span key={i}>{userRoles.find((r) => r.value === role)?.label}</span>;
				})}
			</td>
			{/* New Created By column (currently empty) */}
			<td></td>
			<td>
				{(canManageUser(user.roles) || user.id === currentUserId) && (
					<>
						<button onClick={() => handleEdit(user.id)}>
							<img src={EditIcon} alt="edit" />
						</button>
						{canManageUser(user.roles) && user.id !== currentUserId && (
							<button onClick={() => handleDelete(user.id)}>
								<img src={DeleteIcon} alt="delete" />
							</button>
						)}
					</>
				)}
			</td>
		</tr>
	));

	return (
		<>
			<Row>
				<Col>
					<STable>
						<thead>
							<tr>
								<td>Username</td>
								<td colSpan={2}>Name</td>
								<td colSpan={2}>E-mail</td>
								<td>Role</td>
								<td>Created by</td>
								<td>Actions</td>
							</tr>
						</thead>
						<tbody>
							{mapped?.length === 0 ? (
								<tr>
									<td colSpan={8}>Users not found</td>
								</tr>
							) : (
								mapped
							)}
						</tbody>
					</STable>
				</Col>
			</Row>
			<ReactModal isOpen={modalIsOpen} onRequestClose={handleClose} style={StyledModal} ariaHideApp={false}>
				{modalType === "EDIT" && userId !== undefined ? (
					<ChangeUserPassword userId={userId} closeModal={handleClose} />
				) : null}
				{modalType === "DELETE" && userId !== undefined ? (
					<DeleteUser userId={userId} refetchUsers={refetchUsers} closeModal={handleClose} />
				) : null}
			</ReactModal>
		</>
	);
};
